<template>
  <div class="d-flex flex-column align-items-center">
    <div class="contents-960 w-100 py-5 d-flex flex-column">
      <span>退会すると、以下の内容が適用されます：</span>

      <span class="text-danger">- すべてのアカウント情報が削除されます </span>
      <span class="text-danger">- ご利用履歴やデータは復元できません </span>
      <span class="text-danger"
        >- 退会後、同じメールアドレスでの再登録が制限されます
      </span>

      <span>
        退会をご希望の場合は、下記の「退会」ボタンを押してください。
      </span>

      <span>
        なお、退会処理をキャンセルする場合は「戻る」ボタンを押してください。
      </span>

      <div class="w-100 d-flex justify-content-center mt-3">
        <OpenSiteBackButton class="me-3" label="戻る" />
        <MoreReadButton
          class="ms-3"
          color="green"
          label="退会"
          button-type="submit"
          :disabled="loading"
          @click="handleSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useUser, useRouterUtil } from "/@/vue/composables";
import {
  BasicButton,
  MoreReadButton,
  OpenSiteBackButton,
} from "/@/vue/components/Atom";
import { PasswordChangeForm } from "/@/vue/components/Organisms";
import { PasswordChange } from "/@/types";

const { goto } = useRouterUtil();

const { getUser, unsubscribe, setUser } = useUser();
const { data: user, mutate: getUserMutate } = getUser();

const loading = ref(false);

async function handleSubmit() {
  loading.value = true;

  if (await unsubscribe()) {
    alert("退会手続きが完了しました");
    await getUserMutate();

    setUser(user.value);

    goto({ name: "UsersShow" });
  } else {
    alert(
      "退会手続きが何らかの理由で失敗しました。更新してもう一度試し、それでもうまくいかない場合は大変お手数ですが運営までお問い合わせをお願いします。"
    );
    loading.value = false;
  }
}
</script>

<style scoped></style>
